export default __webpack_public_path__ + "static/media/dislike-outline.fd99fd6d.svg";